export type ProductKind = 'unit' | 'parking' | 'rack' | 'legal_address' | 'insurance';

export interface PeriodPrice {
  period: string;
  total: number;
  totalBefore: number;
}

/** Quotes for requested periods; one product → one currency. */
export interface ShowcasePrices {
  items: PeriodPrice[];
  currency: string;
}

export interface ShowcasePricesParams {
  productKind?: ProductKind;
  facility?: string;
  productCode?: string;
  startedAt?: string;
  promo?: string;
  showcase?: string[];
}

/** Periods shown as plan cards on the rent payment step. */
export const RENT_SHOWCASE_PERIODS = ['1w', '1m', '6m', '11m'] as const;

export const SHOWCASE_PERIODS = [
  '1w', '2w', '3w', '4w',
  '1m', '2m', '3m', '4m', '5m', '6m', '7m', '8m', '9m', '10m', '11m',
] as const;
